export const limitCharacters = (text: string, maxCharCount: number): string => {
  if (text.length <= maxCharCount) {
    return text;
  }
  return text.slice(0, maxCharCount);
};
